<template>
  <v-container fluid tag="section">
    <v-row justify="center">
      <!-- <v-col cols="12" lg="4">
        <demo-comp-1 />
      </v-col>
      <v-col cols="12" lg="4">
        <demo-comp-2 />
      </v-col> -->
      <v-col cols="12" lg="4"> {{ yourValue }} </v-col>
      <v-col cols="12" lg="4">
        <z-date-time-picker v-model="yourValue" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { VueEditor, Quill } from "vue2-editor";
import TripStats from "@/views/dashboard/TripStats.vue";
import DemoComp1 from "@/views/demo/DemoComp1.vue";
import DemoComp2 from "@/views/demo/DemoComp2.vue";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

@Component({
  components: {
    TripStats,
    DemoComp1,
    DemoComp2,
    VueCtkDateTimePicker,
  },
})
export default class Demo extends Vue {
  shift = null;
  corp = null;
  consignor = null;
  vehicleType = "en";
  tax_id = "5f71b30c48f8a60001c30ae0";
  vendor_id = "5546538fe4b07d94be9d3fa1";
  item = {};
  yourValue = 1610730900;

  fullTax(taxDetail, item) {
    const it = item;
    if (!it.taxDetail) {
      it.taxDetail = null;
    }
    it.taxDetail = taxDetail;
    item = it;
  }

  migrate = {};

  emailsSubscriptionChart = {
    data: {
      labels: ["Ja", "Fe", "Ma"],
      series: [542, 443, 320],
    },
    options: {
      axisX: {
        showGrid: false,
      },
      low: 0,
      high: 1000,
      chartPadding: {
        top: 0,
        right: 5,
        bottom: 0,
        left: 0,
      },
    },
    responsiveOptions: [
      [
        "screen and (max-width: 640px)",
        {
          seriesBarDistance: 5,
          axisX: {
            labelInterpolationFnc: function (value) {
              return value[0];
            },
          },
        },
      ],
    ],
  };

  @Watch("migrate", { deep: true })
  onMigateChange(val, oldVal) {
    // console.log(val);
    // console.log(oldVal);
    this.migrate = val;
  }

  selectDriver(v) {
    this.driver = v[0];
  }

  mounted() {
    const eventHub = new Vue(); // Single event hub

    // Distribute to components using global mixin
    Vue.mixin({
      data: function () {
        return {
          eventHub: eventHub,
        };
      },
    });
  }
}
</script>

<style>
.field-input[data-v-5b500588] {
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0;
}
</style>
